<p-menu
  #menu
  [model]="$loading() ? [] : model"
  [popup]="popup"
  [ariaLabel]="ariaLabel"
  [ariaLabelledBy]="ariaLabelledBy"
  [id]="id"
  [appendTo]="appendTo"
  [styleClass]="'osp-menu-overlay ' + styleClass"
  (onShow)="$onShow.emit($event)"
  (onHide)="$onHide.emit($event)"
>
  <ng-template pTemplate="start" let-menu>
    @if ($loading()) {
      <div class="flex align-content-center justify-content-center align-items-center m-2">
        <osp-spinner [size]="'small'" />
      </div>
    }
  </ng-template>

  <ng-template pTemplate="item" let-item>
    <div
      class="menu-item-container"
      [ngStyle]="{ 'pointer-events': 'auto' }"
      [ospTooltip]="item?.tooltip"
      [tooltipPosition]="'top'"
    >
      <a
        pRipple
        class="p-element p-menuitem-link"
        data-pc-section="action"
        aria-hidden="true"
        [ngClass]="{ 'p-disabled': item?.disabled }"
        [href]="item.url || ''"
        [target]="item.target || '_self'"
      >
        <span class="p-menuitem-text">
          @if (item?.icon) {
            <span class="mr-2"><i [className]="item?.icon"></i></span>
          }
          {{ item?.label }}
        </span>
      </a>
    </div>
  </ng-template>
</p-menu>
